"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Leavitt = void 0;
const Colony_1 = require("../../../colonies/Colony");
const ColonyName_1 = require("../../../colonies/ColonyName");
const ColonyBenefit_1 = require("../../../colonies/ColonyBenefit");
class Leavitt extends Colony_1.Colony {
    constructor() {
        super(...arguments);
        this.name = ColonyName_1.ColonyName.LEAVITT;
        this.description = 'Science';
        this.buildType = ColonyBenefit_1.ColonyBenefit.GAIN_SCIENCE_TAG;
        this.tradeType = ColonyBenefit_1.ColonyBenefit.DRAW_CARDS_AND_KEEP_ONE;
        this.tradeQuantity = [1, 2, 3, 4, 5, 6, 7];
        this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.DRAW_CARDS_AND_BUY_ONE;
        this.priority = 2;
        this.details = [
            'Gain 1 Science tag',
            'Draw n cards and keep 1',
            'Reveal and buy or discard\nthe top card of the deck',
        ];
    }
}
exports.Leavitt = Leavitt;
//# sourceMappingURL=Leavitt.js.map